module.exports = __webpack_public_path__ + "media/images/icon/button-new-jobs-a1f3f0939db7ab61af9bbffe5de35a49.png";